<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@addNewProduct">Add New Product</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  @if (selected === 'newProduct') {
    <div class="mb-24 d-flex img-container">
      <div>
        <div (click)="addProductImage()" class="add-rectangle cursor d-inline-flex justify-content-center align-items-center">
          <mat-icon class="add-icon" i18n-aria-label="@@addImage" aria-label="Add image">add</mat-icon>
        </div>
      </div>
      @for (img of imagesList; track img; let i = $index) {
        <div  class="d-inline-flex flex-column align-items-center ml-8">
          <img [src]="img" i18n-alt="@@productImage" alt="Product image {{i + 1}}" />
          <mat-icon (click)="deleteProductImage(i)" color="warn" class="delete-icon cursor" i18n-aria-label="@@deleteImage" aria-label="Delete image">cancel</mat-icon>
        </div>
      }
    </div>
  }
  @if (invalidImages && selected === 'newProduct') {
    <div i18n="@@invalidImageMessage" class="error">Please add image to proceed</div>
  }
  @if (selected === 'newProduct') {
    <mat-divider class="mb-24"></mat-divider>
  }
  @if (user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) {
    <mat-form-field appearance="outline" class="w-100">
      <mat-select data-testid="addProduct_filter" (selectionChange)="filterChange($event.value)" [(value)]="selected" #addProduct_filter  id="addProduct_filter"
        name="addProduct_filter">
        <mat-option i18n="@@newProduct" value="newProduct">New product</mat-option>
        <mat-option i18n="@@applyForManufacturerSupport" value="fromManufacturer">Apply for manufacturer support</mat-option>
      </mat-select>
    </mat-form-field>
  }
  @if (selected === 'newProduct') {
    <form [formGroup]="addProductForm">
      <div class="form-group">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label i18n="@@productNameLabel">Product name</mat-label>
          <input data-testid="add_product_name_input"  matInput id="name" i18n-placeholder="@@productNamePlaceholder" placeholder="Product name" name="name" formControlName="name" required />
          <mat-error>
            @if (!addProductForm.get('name').valid && addProductForm.get('name').touched) {
              @if (addProductForm.get('name').errors && addProductForm.get('name').errors['required'] || addProductForm.get('name').hasError('whitespace')) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label i18n="@@descriptionLabel">Description</mat-label>
          <textarea data-testid="add_description_input"  matInput id="description" i18n-placeholder="@@descriptionPlaceholder" placeholder="Description" name="description" formControlName="description" required></textarea>
          <mat-error>
            @if (!addProductForm.get('description').valid && addProductForm.get('description').touched) {
              @if (addProductForm.get('description').errors && addProductForm.get('description').errors['required'] || addProductForm.get('description').hasError('whitespace')) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label i18n="@@purposeLabel">Purpose</mat-label>
          <textarea data-testid="add_product_purpose_input"  matInput id="purpose" i18n-placeholder="@@purposePlaceholder" placeholder="Purpose" name="purpose" formControlName="purpose" required ></textarea>
          <mat-error>
            @if (!addProductForm.get('purpose').valid && addProductForm.get('purpose').touched) {
              @if (addProductForm.get('purpose').errors && addProductForm.get('purpose').errors['required'] || addProductForm.get('purpose').hasError('whitespace')) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-chip-grid #chipList>
            @for (department of departments; track department; let index = $index) {
              <mat-chip-row
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(department, index)">
                {{department.name}}
                @if (removable) {
                  <mat-icon matChipRemove i18n-aria-label="@@removeDepartment" aria-label="Remove department">cancel</mat-icon>
                }
              </mat-chip-row>
            }
            <input
              data-testid="add_product_department_input"
              (keyup)="searchDepartment($event)"
              i18n-placeholder="@@departmentsPlaceholder"
              placeholder="Departments *"
              #departmentInput
              required
              [formControl]="departmentCtrl"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add($event)">
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedDepartment($event)">
              @for (department of filteredDepartments | async; track department) {
                <mat-option [value]="department">
                  {{department.name}}
                </mat-option>
              }
            </mat-autocomplete>
            @if (isLoading) {
              <mat-icon class="cursor" matSuffix>
                <mat-spinner class="spinner" diameter="20"></mat-spinner>
              </mat-icon>
            }
          </mat-form-field>
          @if (invalidDepartments) {
            <div i18n="@@invalidDepartmentsMessage" class="error">Please enter departments to proceed</div>
          }
        </div>
        <div mat-dialog-actions>
          <button i18n="@@add" data-testid="add_product_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Add</button>
        </div>
      </form>
    }
    @if (selected !== 'newProduct') {
      <form [formGroup]="addProductFromManufacturerForm">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label i18n="@@manufacturer">Manufacturer</mat-label>
          <mat-select (selectionChange)="manufacturerFilterChange()" name="manufacturer" id="manufacturer" i18n-placeholder="@@selectManufacturer" placeholder="Select manufacturer" formControlName="manufacturer" required data-testid="manufacturer_input">
            @for (item of manufacturersList; track item; let itemIndex = $index) {
              <mat-option [value]="item.id">{{item.businessName}}</mat-option>
            }
          </mat-select>
          <mat-error>
            @if (!addProductFromManufacturerForm.get('manufacturer').valid && addProductFromManufacturerForm.get('manufacturer').touched) {
              @if (addProductFromManufacturerForm.get('manufacturer').errors && addProductFromManufacturerForm.get('manufacturer').errors['required']) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100">
          <mat-select data-testid="newProduct_filter" (selectionChange)="productFilterChange($event.value)" [(value)]="productSelected" #newProduct_filter  id="newProduct_filter"
            name="newProduct_filter">
            <mat-option i18n="@@selectProduct" value="newProduct">Select product</mat-option>
            <mat-option i18n="@@askManufacturerAddNewProduct" value="fromManufacturer">Ask manufacturer to add new product</mat-option>
          </mat-select>
        </mat-form-field>
        @if (productSelected !== 'newProduct') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label i18n="@@productNameLabel">Product name</mat-label>
            <input data-testid="add_product_name_input"  matInput id="productName" i18n-placeholder="@@productNamePlaceholder" placeholder="Product name" name="productName" formControlName="productName" required />
            <mat-error>
              @if (!addProductFromManufacturerForm.get('productName').valid && addProductFromManufacturerForm.get('productName').touched) {
                @if (addProductFromManufacturerForm.get('productName').errors && addProductFromManufacturerForm.get('productName').errors['required'] || addProductFromManufacturerForm.get('productName').hasError('whitespace')) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
            </mat-error>
          </mat-form-field>
        }
        @if (productSelected === 'newProduct') {
          <mat-form-field class="w-100" appearance="outline">
            <mat-label i18n="@@products">Products</mat-label>
            <mat-chip-grid #chipList>
              @for (product of products; track product; let index = $index) {
                <mat-chip-row
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="removeProduct(product, index)">
                  {{product.name}}
                  @if (removable) {
                    <mat-icon matChipRemove i18n-aria-label="@@removeProduct" aria-label="Remove product">cancel</mat-icon>
                  }
                </mat-chip-row>
              }
              <input
                data-testid="add_edit_product_products_input"
                (keyup)="searchProduct($event)"
                i18n-placeholder="@@productsPlaceholder"
                placeholder="Products"
                #productInput
                required
                [formControl]="productCtrl"
                [matAutocomplete]="autoProduct"
                [matChipInputFor]="chipList"
                (matChipInputTokenEnd)="addProduct($event)">
              </mat-chip-grid>
              <mat-autocomplete #autoProduct="matAutocomplete" (optionSelected)="selectedProduct($event)">
                @for (product of filteredProducts | async; track product) {
                  <mat-option [value]="product">
                    {{product.name}}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (isLoading) {
                <mat-icon class="cursor" matSuffix>
                  <mat-spinner class="spinner" diameter="20"></mat-spinner>
                </mat-icon>
              }
            </mat-form-field>
          }
          @if (products.length === 0 && productSelected === 'newProduct') {
            <div i18n="@@invalidProducts" class="error">Please enter products to proceed!</div>
          }
          <div mat-dialog-actions>
            <button i18n="@@sendEmail" data-testid="sendEmail_button" class="w-100" mat-raised-button color="primary" (click)="sendEmail()">Send email</button>
          </div>
        </form>
      }
</mat-dialog-content>